import { Injectable } from '@angular/core';
import { ApiService } from '../shared/api.service';
import { environment } from '../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SiteService {

  private api_url: string;
  private ttl: number;

  private status = null;
  private statusObservable = null;
  private statusStamp = new Date();

  constructor(private apiService: ApiService) {
    this.api_url = environment.cdt.api_url;
    this.ttl = environment.cdt.ttl;
  }

  getStatusFromOrganizationIdWithCache(organizationId: string): Observable<any> {
    if (this.status && ((<any>(new Date()) - <any>this.statusStamp) < (this.ttl * 1000))) {
      return of(this.status);
    } else if (this.statusObservable) {
      return this.statusObservable;
    } else {
      this.statusObservable = this.getStatusFromOrganizationId(organizationId)
        .map(response => {
          this.statusObservable = null;
          this.status = (<any>response);
          this.statusStamp = new Date();
          return response;
        })
        .share();
      return this.statusObservable;
    }
  }

  getStatusFromOrganizationId(organizationId: string): Observable<any> {
    return this.apiService.get('sites/organization/' + organizationId + '/status', this.api_url);
  }

  getModelId(organizationId: string): Observable<string> {
    return this.apiService.get('sites/model?organizationId=' + organizationId, this.api_url);
  }

  createModelId(organizationId: string): Observable<string> {
    return this.apiService.put('contextDiscovery?organizationId=' + organizationId, this.api_url);
  }

  getModelPresenceStatus(modelId: string): Observable<boolean> {
    return this.apiService.get('sites/model/' + modelId + '/modelPresent', this.api_url);
  }

  uploadKeymapFile(modelId: string, fileToUpload: File) {
    const formData = new FormData();
    formData.append('keymapFile', fileToUpload, fileToUpload.name);
    return this.apiService.post('sites/' + modelId + '/keymap', this.api_url, formData, new HttpHeaders());
  }

  getUploadedKeymapFileName(modelId: string): Observable<string> {
    return this.apiService.get('sites/' + modelId + '/keymap/name', this.api_url);
  }

  getModelCreatedStatus(organizationId: String): Observable<any> {
    return this.apiService.get('sites/' + organizationId + '/isModelCreated', this.api_url);
  }
}
